/*
  LLC: "Show more products" for collection and search grids (see snippets/llc-load-more.liquid).
  Fetches the next page through the Section Rendering API and appends its product cards.
  Uses a single delegated listener, so it keeps working after Horizon re-renders the grid
  when filters or sorting change.
*/
(function () {
  if (window.llcLoadMoreReady) return;
  window.llcLoadMoreReady = true;

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-llc-load-more-button]');
    if (!button) return;

    var wrap = button.closest('[data-llc-load-more]');
    var container = wrap && (wrap.closest('results-list') || wrap.parentElement);
    var grid = container && container.querySelector('.product-grid');
    if (!wrap || !grid) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var label = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading…';

    try {
      var url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', wrap.dataset.sectionId);

      var response = await fetch(url.toString());
      if (!response.ok) throw new Error('Request failed: ' + response.status);

      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var nextGrid = doc.querySelector('.product-grid');
      var items = nextGrid ? nextGrid.querySelectorAll(':scope > li') : [];
      var firstNew = null;

      items.forEach(function (item) {
        var node = document.importNode(item, true);
        if (!firstNew) firstNew = node;
        grid.appendChild(node);
      });

      var nextWrap = doc.querySelector('[data-llc-load-more]');
      if (nextWrap) {
        wrap.replaceWith(document.importNode(nextWrap, true));
      } else {
        wrap.remove();
      }

      // Move keyboard focus to the first new product so keyboard users continue from there.
      var focusTarget = firstNew && firstNew.querySelector('a[href]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    } catch (error) {
      // Fall back to a normal page load of the next page.
      window.location.href = button.href;
      button.textContent = label;
      button.removeAttribute('aria-busy');
    }
  });
})();
